export const SKU_LIST_G5000: string[] = [ 
    "G5000-Bl-S",
    "G5000-Bl-M",
    "G5000-Bl-L",
    "G5000-Bl-XL",
    "G5000-Bl-2XL",
    "G5000-Bl-3XL",
    "G5000-Bl-4XL",
    "G5000-Bl-5XL",
    "G5000-MilGr-S",
    "G5000-MilGr-M",
    "G5000-MilGr-L",
    "G5000-MilGr-XL",
    "G5000-MilGr-2XL",
    "G5000-MilGr-3XL",
    "G5000-MilGr-4XL",
    "G5000-MilGr-5XL",
    "G5000-AshGy-S",
    "G5000-AshGy-M",
    "G5000-AshGy-L",
    "G5000-AshGy-XL",
    "G5000-AshGy-2XL",
    "G5000-AshGy-3XL",
    "G5000-Or-S",
    "G5000-Or-M",
    "G5000-Or-L",
    "G5000-Or-XL",
    "G5000-Or-2XL",
    "G5000-Or-3XL",
    "G5000-Or-4XL",
    "G5000-Or-5XL",
    "G5000-DaHe-S",
    "G5000-DaHe-M",
    "G5000-DaHe-L",
    "G5000-DaHe-XL",
    "G5000-DaHe-2XL",
    "G5000-DaHe-3XL",
    "G5000-DaHe-4XL",
    "G5000-DaHe-5XL",
    "G5000-Go-S",
    "G5000-Go-M",
    "G5000-Go-L",
    "G5000-Go-XL",
    "G5000-Go-2XL",
    "G5000-Go-3XL",
    "G5000-Go-4XL",
    "G5000-Go-5XL",
    "G5000-San-S",
    "G5000-San-M",
    "G5000-San-L",
    "G5000-San-XL",
    "G5000-San-2XL",
    "G5000-San-3XL",
    "G5000-San-4XL",
    "G5000-San-5XL",
    "G5000-LiBl-S",
    "G5000-LiBl-M",
    "G5000-LiBl-L",
    "G5000-LiBl-XL",
    "G5000-LiBl-2XL",
    "G5000-LiBl-3XL",
    "G5000-Ma-S",
    "G5000-Ma-M",
    "G5000-Ma-L",
    "G5000-Ma-XL",
    "G5000-Ma-2XL",
    "G5000-Ma-3XL",
    "G5000-Ma-4XL",
    "G5000-Ma-5XL",
    "G5000-IrGr-S",
    "G5000-IrGr-M",
    "G5000-IrGr-L",
    "G5000-IrGr-XL",
    "G5000-IrGr-2XL",
    "G5000-IrGr-3XL",
    "G5000-IrGr-4XL",
    "G5000-IrGr-5XL",
    "G5000-Pu-S",
    "G5000-Pu-M",
    "G5000-Pu-L",
    "G5000-Pu-XL",
    "G5000-Pu-2XL",
    "G5000-Pu-3XL",
    "G5000-Pu-4XL",
    "G5000-Pu-5XL",
    "G5000-Cha-S",
    "G5000-Cha-M",
    "G5000-Cha-L",
    "G5000-Cha-XL",
    "G5000-Cha-2XL",
    "G5000-Cha-3XL",
    "G5000-Cha-4XL",
    "G5000-Cha-5XL",
    "G5000-Wh-S",
    "G5000-Wh-M",
    "G5000-Wh-L",
    "G5000-Wh-XL",
    "G5000-Wh-2XL",
    "G5000-Wh-3XL",
    "G5000-Wh-4XL",
    "G5000-Wh-5XL",
    "G5000-Na-S",
    "G5000-Na-M",
    "G5000-Na-L",
    "G5000-Na-XL",
    "G5000-Na-2XL",
    "G5000-Na-3XL",
    "G5000-Na-4XL",
    "G5000-Na-5XL",
    "G5000-DaCho-S",
    "G5000-DaCho-M",
    "G5000-DaCho-L",
    "G5000-DaCho-XL",
    "G5000-DaCho-2XL",
    "G5000-DaCho-3XL",
    "G5000-DaCho-4XL",
    "G5000-DaCho-5XL",
    "G5000-OldGo-S",
    "G5000-OldGo-M",
    "G5000-OldGo-L",
    "G5000-OldGo-XL",
    "G5000-OldGo-2XL",
    "G5000-OldGo-3XL",
    "G5000-Re-S",
    "G5000-Re-M",
    "G5000-Re-L",
    "G5000-Re-XL",
    "G5000-Re-2XL",
    "G5000-Re-3XL",
    "G5000-Re-4XL",
    "G5000-Re-5XL",
    "G5000-Ro-S",
    "G5000-Ro-M",
    "G5000-Ro-L",
    "G5000-Ro-XL",
    "G5000-Ro-2XL",
    "G5000-Ro-3XL",
    "G5000-Ro-4XL",
    "G5000-Ro-5XL",
    "G5000-SpGr-S",
    "G5000-SpGr-M",
    "G5000-SpGr-L",
    "G5000-SpGr-XL",
    "G5000-SpGr-2XL",
    "G5000-SpGr-3XL",
    "G5000-SpGr-4XL",
    "G5000-SpGr-5XL",
    "G5000-LiPi-S",
    "G5000-LiPi-M",
    "G5000-LiPi-L",
    "G5000-LiPi-XL",
    "G5000-LiPi-2XL",
    "G5000-LiPi-3XL",
    "G5000-LiPi-4XL",
    "G5000-LiPi-5XL",
    "G5000-Ta-S",
    "G5000-Ta-M",
    "G5000-Ta-L",
    "G5000-Ta-XL",
    "G5000-Ta-2XL",
    "G5000-Ta-3XL",
    "G5000-SaGr-S",
    "G5000-SaGr-M",
    "G5000-SaGr-L",
    "G5000-SaGr-XL",
    "G5000-SaGr-2XL",
    "G5000-SaGr-3XL",
    "G5000-SaGr-4XL",
    "G5000-SaGr-5XL",
    "G5000-Tw-S",
    "G5000-Tw-M",
    "G5000-Tw-L",
    "G5000-Tw-XL",
    "G5000-Tw-2XL",
    "G5000-Tw-3XL",
    "G5000-AnIrGr-S",
    "G5000-AnIrGr-M",
    "G5000-AnIrGr-L",
    "G5000-AnIrGr-XL",
    "G5000-AnIrGr-2XL",
    "G5000-AnIrGr-3XL",
    "G5000-AnJaDo-S",
    "G5000-AnJaDo-M",
    "G5000-AnJaDo-L",
    "G5000-AnJaDo-XL",
    "G5000-AnJaDo-2XL",
    "G5000-AnJaDo-3XL",
    "G5000-AnOr-S",
    "G5000-AnOr-M",
    "G5000-AnOr-L",
    "G5000-AnOr-XL",
    "G5000-AnOr-2XL",
    "G5000-AnOr-3XL",
    "G5000-AnSa-S",
    "G5000-AnSa-M",
    "G5000-AnSa-L",
    "G5000-AnSa-XL",
    "G5000-AnSa-2XL",
    "G5000-AnSa-3XL",
    "G5000-Az-S",
    "G5000-Az-M",
    "G5000-Az-L",
    "G5000-Az-XL",
    "G5000-Az-2XL",
    "G5000-Az-3XL",
    "G5000-Blbr-S",
    "G5000-Blbr-M",
    "G5000-Blbr-L",
    "G5000-Blbr-XL",
    "G5000-Blbr-2XL",
    "G5000-Blbr-3XL",
    "G5000-CaRe-S",
    "G5000-CaRe-M",
    "G5000-CaRe-L",
    "G5000-CaRe-XL",
    "G5000-CaRe-2XL",
    "G5000-CaRe-3XL",
    "G5000-CaBl-S",
    "G5000-CaBl-M",
    "G5000-CaBl-L",
    "G5000-CaBl-XL",
    "G5000-CaBl-2XL",
    "G5000-CaBl-3XL",
    "G5000-Cob-S",
    "G5000-Cob-M",
    "G5000-Cob-L",
    "G5000-Cob-XL",
    "G5000-Cob-2XL",
    "G5000-Cob-3XL",
    "G5000-Cor-S",
    "G5000-Cor-M",
    "G5000-Cor-L",
    "G5000-Cor-XL",
    "G5000-Cor-2XL",
    "G5000-Cor-3XL",
    "G5000-FoGr-S",
    "G5000-FoGr-M",
    "G5000-FoGr-L",
    "G5000-FoGr-XL",
    "G5000-FoGr-2XL",
    "G5000-FoGr-3XL",
    "G5000-FoGr-4XL",
    "G5000-FoGr-5XL",
    "G5000-Nat-S",
    "G5000-Nat-M",
    "G5000-Nat-L",
    "G5000-Nat-XL",
    "G5000-Nat-2XL",
    "G5000-Nat-3XL",
    "G5000-Da-S",
    "G5000-Da-M",
    "G5000-Da-L",
    "G5000-Da-XL",
    "G5000-Da-2XL",
    "G5000-Da-3XL",
    "G5000-Da-4XL",
    "G5000-Da-5XL",
    "G5000-HeSa-S",
    "G5000-HeSa-M",
    "G5000-HeSa-L",
    "G5000-HeSa-XL",
    "G5000-HeSa-2XL",
    "G5000-HeSa-3XL",
    "G5000-AnChRe-S",
    "G5000-AnChRe-M",
    "G5000-AnChRe-L",
    "G5000-AnChRe-XL",
    "G5000-AnChRe-2XL",
    "G5000-AnChRe-3XL",
    "G5000-Ru-S",
    "G5000-Ru-M",
    "G5000-Ru-L",
    "G5000-Ru-XL",
    "G5000-Ru-2XL",
    "G5000-Ru-3XL",
    "G5000-Mini-S",
    "G5000-Mini-M",
    "G5000-Mini-L",
    "G5000-Mini-XL",
    "G5000-Mini-2XL",
    "G5000-Mini-3XL",
    "G5000-Su-S",
    "G5000-Su-M",
    "G5000-Su-L",
    "G5000-Su-XL",
    "G5000-Su-2XL",
    "G5000-Su-3XL",
    "G5000-Lil-S",
    "G5000-Lil-M",
    "G5000-Lil-L",
    "G5000-Lil-XL",
    "G5000-Lil-2XL",
    "G5000-Lil-3XL",
    "G5000-MiGr-S",
    "G5000-MiGr-M",
    "G5000-MiGr-L",
    "G5000-MiGr-XL",
    "G5000-MiGr-2XL",
    "G5000-MiGr-3XL",
    "G5000-InBl-S",
    "G5000-InBl-M",
    "G5000-InBl-L",
    "G5000-InBl-XL",
    "G5000-InBl-2XL",
    "G5000-InBl-3XL",
    "G5000-GrHe-S",
    "G5000-GrHe-M",
    "G5000-GrHe-L",
    "G5000-GrHe-XL",
    "G5000-GrHe-2XL",
    "G5000-GrHe-3XL",
    "G5000-Li-S",
    "G5000-Li-M",
    "G5000-Li-L",
    "G5000-Li-XL",
    "G5000-Li-2XL",
    "G5000-Li-3XL",
    "G5000-YeHa-S",
    "G5000-YeHa-M",
    "G5000-YeHa-L",
    "G5000-YeHa-XL",
    "G5000-YeHa-2XL",
    "G5000-YeHa-3XL",
    "G5000-Sap-S",
    "G5000-Sap-M",
    "G5000-Sap-L",
    "G5000-Sap-XL",
    "G5000-Sap-2XL",
    "G5000-Sap-3XL",
    "G5000-Vi-S",
    "G5000-Vi-M",
    "G5000-Vi-L",
    "G5000-Vi-XL",
    "G5000-Vi-2XL",
    "G5000-Vi-3XL",
    "G5000-Ki-S",
    "G5000-Ki-M",
    "G5000-Ki-L",
    "G5000-Ki-XL",
    "G5000-Ki-2XL",
    "G5000-Ki-3XL",
    "G5000-Sky-S",
    "G5000-Sky-M",
    "G5000-Sky-L",
    "G5000-Sky-XL",
    "G5000-Sky-2XL",
    "G5000-Sky-3XL",
    "G5000-Hel-S",
    "G5000-Hel-M",
    "G5000-Hel-L",
    "G5000-Hel-XL",
    "G5000-Hel-2XL",
    "G5000-Hel-3XL",
    "G5000-OffWh-3XL",
    "G5000-OffWh-4XL"
];